// removed by extract-text-webpack-plugin
module.exports = {"loading":"loading__loading___2FzLv","spinner":"loading__spinner___3EBql"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/common/loading.scss
// module id = 1309
// module chunks = 0